import React from "react";

const CloseIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
            <path d="M18.9316 6.70518C19.2455 6.39127 19.2455 5.88231 18.9316 5.56839C18.6177 5.25448 18.1087 5.25448 17.7948 5.5684L12.5 10.8632L7.20518 5.5684C6.89126 5.25448 6.38231 5.25448 6.06839 5.56839C5.75448 5.88231 5.75448 6.39126 6.06839 6.70518L11.3632 12L6.06839 17.2948C5.75448 17.6088 5.75448 18.1177 6.06839 18.4316C6.38231 18.7455 6.89126 18.7455 7.20518 18.4316L12.5 13.1368L17.7948 18.4316C18.1087 18.7455 18.6177 18.7455 18.9316 18.4316C19.2455 18.1177 19.2455 17.6088 18.9316 17.2948L13.6368 12L18.9316 6.70518Z" fill="white" />
        </svg>
    );
};

export default CloseIcon;
